
//Modal para confirmar la eliminacion de una obra
import { Modal, Button } from "react-bootstrap";
import {  FaTrash } from "react-icons/fa"; 
import {  FaTimesCircle } from "react-icons/fa";
const ConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header className="d-flex justify-content-center">
        <div>
        <Modal.Title className="text-center text-muted">Confirmación</Modal.Title>
        </div>
      </Modal.Header >
      <Modal.Body className="d-flex justify-content-center align-items-center text-center">
  <p className="mb-0">¿Estás seguro de que deseas eliminar esta obra? Esta acción no se puede deshacer.</p>
</Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
  <div className="d-flex gap-2 w-100">
    <Button 
      className="btn btn-secondary btn-sm w-50 d-flex align-items-center gap-2 justify-content-center" 
      onClick={onClose}
    >
      <FaTimesCircle className="ms-1" /> Cancelar
    </Button>
    <Button 
      className="btn btn-danger btn-sm w-50 d-flex align-items-center gap-2 justify-content-center" 
      onClick={onConfirm}
    >
      <FaTrash className="ms-1"/> Eliminar
    </Button>
  </div>
</Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
